import React, { useMemo } from 'react';
import { Table, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import PatientSelect from '../../components/patient/PatientSelect';
import PatientEmptyState from '../patient/PatientEmptyState';

const { Title } = Typography;

export default function PatientList({ patients, pagination, onPageChange }) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handlePatientSelected = (patient) => {
    if (patient) navigate(`/patients/${patient.getUUID()}`);
  };

  const columns = useMemo(() => [
    {
      title: '',
      dataIndex: 'full_name',
      key: 'full_name',
      render: (text, record) => (
        <Link to={`/patients/${record.getUUID()}`}>{record.getFullName()}</Link>
      ),
    },
    {
      title: '',
      key: 'sex_age',
      responsive: ['md'],
      render: (text, record) => record.getDemographics()
    },
  ], [t]);

  if (patients.length === 0) {
    return <PatientEmptyState />;
  }

  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 16, marginBottom: 16, float: 'right' }}>
        <PatientSelect
          selectedPatient={null}
          onSelect={handlePatientSelected}
          selectStyle = {{ minWidth: '250px' }}
          placeholder = {t('patient_selector_panel.search_placeholder')}
        />
      </div>

      <Table
        showHeader={false}
        columns={columns}
        dataSource={patients}
        rowKey={(record) => record.getUUID()}
        pagination={
          pagination.total > pagination.pageSize
            ? { ...pagination, position: ['bottomCenter'] }
            : false
        }
        onChange={(pagination) => onPageChange(pagination.current)}
      />
    </>
  );
}